// Order of detail columns (from API) — labels via i18n
export const DETAIL_KEYS = [
  'pct_of_high_120',
  'atrpct10',
  'range10',
  'range20',
  'vol_dry_10_20',
  'closepos_good_count_10',
  'upvol_ratio20',
  'rs20',
  'stop10',
];

// Metadata cho từng metric: chỉ giữ goodRange, name và tooltip sẽ load từ i18n
export const DETAIL_META = {
  'pct_of_high_120': {
    goodRange: [0.80, 0.95],
  },
  'atrpct10': {
    goodRange: [0, 0.04],
  },
  'range10': {
    goodRange: [0, 0.12],
  },
  'range20': {
    goodRange: [0, 0.15],
  },
  'vol_dry_10_20': {
    goodRange: [0, 0.85],
  },
  'closepos_good_count_10': {
    goodRange: [6, 10],
  },
  'upvol_ratio20': {
    goodRange: [0.55, 1],
  },
  'rs20': {
    goodRange: [1.0, 2.0],
  },
  'stop10': {
    goodRange: null,
  },
};

// Helper: Đánh giá giá trị có tốt không
export const isGoodValue = (key, value) => {
  const meta = DETAIL_META[key];
  if (!meta || !meta.goodRange || value == null) return null;
  const [min, max] = meta.goodRange;
  return value >= min && value <= max;
};

export const formatVolume = (v) => {
  if (v == null || v === '') return '—';
  const n = Number(v);
  if (n >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(2)}K`;
  return n.toLocaleString('vi-VN');
};

// "Waiting for" items — translation keys for i18n (only when no trigger: neither breakout nor early)
export const getWaitingForKeys = (row) => {
  if (row.trigger_flag || row.early_trigger_flag) return null;
  if (!row.setup_flag || !row.details) return null;
  const d = row.details;
  const missing = [];
  if (!d.break20) missing.push('waitingBreak20');
  if (!d.vol_burst) missing.push('waitingVolBurst');
  if (!d.close_strong_trig) missing.push('waitingCloseStrong');
  return missing.length ? missing : null;
};

export const formatRiskPct = (v) => (v != null && !Number.isNaN(Number(v))) ? `${(Number(v) * 100).toFixed(2)}%` : '—';
export const formatSize = (v) => (v != null && !Number.isNaN(Number(v)) && Number(v) > 0) ? `${(Number(v) * 100).toFixed(0)}%` : '—';
export const formatDate = (v) => (v && (typeof v === 'string' || v instanceof Date)) ? new Date(v).toLocaleDateString() : '—';

export const cellDense = { py: 0.5, fontSize: '0.75rem' };

export const stickyLeft = (px) => ({
  position: 'sticky',
  left: px,
  zIndex: 1,
  backgroundColor: 'inherit',
  boxShadow: px > 0 ? '2px 0 4px -2px rgba(0,0,0,0.08)' : 'none',
});

export const STICKY_HEADER_Z = 12;
export const STICKY_BODY_Z = 10;

export const stickyLayer = {
  transform: 'translateZ(0)',
  willChange: 'transform',
};

export const STICKY_BG_DEFAULT = '#ffffff';
export const STICKY_BG_TRIGGER = '#e8f5e9';
export const STICKY_BG_HOVER = '#f5f5f5';

export const stickyBodyBg = (isTriggerOrEarly) =>
  isTriggerOrEarly ? STICKY_BG_TRIGGER : STICKY_BG_DEFAULT;

export const formatDetailValue = (key, value) => {
  if (value == null) return '—';
  if (key === 'closepos_good_count_10') return String(value);
  if (key === 'stop10') return Number(value).toLocaleString('vi-VN');
  return `${(Number(value) * 100).toFixed(1)}%`;
};
